import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/dyami.webp';
import screenshot_target from '../../../images/letterfunnel/ericschouten.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Eric Schouten"
      firstname="Eric"
      companyname="Dyami"
      competition="Forth en Osprey"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/ericschouten.js